import * as types from './mutation-types'

export default {
    [types.LOAD_STANDS](state, data) {
      state.stands = data.data
    },
}
